import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import type { NavItem, SharedData } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import CardMenuButton from './CardMenuButton.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CardMenu',
  props: {
    class: {},
    items: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasPermission } = usePermissions();

    const navItems = computed(() => {
        return props.items.filter(
            (item) => !item.permissionLevel || hasPermission(item.permissionLevel as Permission),
        );
    });

    const page = usePage<SharedData>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-slot": "card-menu",
    class: _normalizeClass(
            _unref(cn)('flex flex-row flex-wrap items-center gap-4 sm:shrink-0 sm:flex-nowrap', props.class)
        )
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (item) => {
      return (_openBlock(), _createBlock(CardMenuButton, {
        key: item.title,
        href: item.href,
        "is-active": item.href === _unref(page).props.ziggy.location
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(item.title)), 1)
        ]),
        _: 2
      }, 1032, ["href", "is-active"]))
    }), 128))
  ], 2))
}
}

})